// import uri from "@/axios/baseUri";
import axios from "@/axios";

    const state = {
            supportAgreements : '',
            organizations : [],
            implementationAgreements : "",
            operationTheatre :"",

            partner_nation_info : {
                organization: '',
                oporation_theatre: '',
                implementation_agreement: '',
                support_agreement:''
            }

    };

    const getters = {
        supportAgreements: state => { return state.supportAgreements},
        organizations : state => { return state.organizations},
        implementationAgreements : state => {return state.implementationAgreements},
        operationTheatre : state => {return state.operationTheatre}
    };

    const mutations = {

        SET_ORGANIZATIONS: (state, response) => { state.organizations = response },
        SET_SUPPORT_AGREEMENTS: (state) => {state.supportAgreements},
        
    };

    const actions = {
        async getOrganizations({commit} ) {
            
           const response = await axios.get('https://localhost:5001/api/organizations')
                .then( (response) => {
                    commit('SET_ORGANIZATIONS', response.data)
                })
                .catch(error => console.log(error)) //not handelled
            
                return response;

        }

    };

    export default {

        state,
        getters,
        mutations,
        actions,
    }